import { CarIconSm, DeliveryIconSm, DineInIconSm, ReceiptIconSm } from '@chownow/pantry/icons';

export const APP_ICON_BASE_URL =
  import.meta.env.VITE_APP_ICON_BASE_URL ?? 'https://assets.cuboh.net/android-image-resources';

// Actions Types
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_CUSTOM_RANGE = 'SET_CUSTOM_RANGE';
export const SET_SALES_GROUPED_PER_HOUR = 'SALES_GROUPED_PER_HOUR';
export const SET_SALES_PER_MERCHANT = 'SALES_PER_MERCHANT';
export const SET_SEND_ALERT = 'SET_SEND_ALERT';
export const SET_ACTIVE_APPS = 'SET_ACTIVE_APPS';
export const SET_ORDER_REPORT = 'SET_ORDER_REPORT';
export const SET_CONTROL_REPORT = 'SET_CONTROL_REPORT';
export const SET_POS_ERROR_REPORT = 'SET_POS_ERROR_REPORT';
export const SET_ADJUSTMENT_REPORT = 'SET_ADJUSTMENT_REPORT';
export const SET_CANCELLATION_REPORT = 'SET_CANCELLATION_REPORT';
export const SET_ITEM_REPORT = 'SET_ITEM_REPORT';
export const SET_MODIFIER_REPORT = 'SET_MODIFIER_REPORT';
export const SET_REPORTING_ERROR = 'SET_REPORTING_ERROR';
export const SET_ORDER_DETAIL = 'SET_ORDER_DETAIL';
export const SET_SELECTED_COMPANIES_AND_MERCHANTS = 'SET_SELECTED_COMPANIES_AND_MERCHANTS';
export const SET_APP_REPORT_FILTER = 'SET_APP_REPORT_FILTER';
export const SET_SHOW_CANCELLED_FILTER = 'SET_SHOW_CANCELLED_FILTER';
export const SET_ACTION_BAR_SELECT_OPTIONS = 'SET_ACTION_BAR_SELECT_OPTIONS';
export const SET_ACTION_BAR_SELECT_VALUES = 'SET_ACTION_BAR_SELECT_VALUES';

// Retry Configuration
export const QUERY_RETRY_DELAY_MS = 1000;
export const AUTO_RETRY_DELAY_MS = 3000;
export const MAX_AUTO_RETRIES = 2;

// Report Types
export const ORDER = 'order';
export const ITEM = 'item';
export const ADJUSTMENT = 'adjustment';
export const CANCELLATIONS = 'cancellations';
export const CONTROL = 'control';
export const ANALYTICS = 'analytics';
export const MODIFIER = 'modifier';
export const ORDER_DETAIL = 'orderDetail';
export const POS_ERROR = 'pos-error';
export const POS_INJECTION = 'POS injection';

export const TEST_ORDER = 'TEST ORDER';

export const STORE_STATUS_UPDATED = 'STORE_STATUS_UPDATED';
export const POS_EXCEPTION = 'POS_EXCEPTION';

export const CHARGE = 'charge';
export const REFUND = 'refund';

export const ERROR = 'error';
export const SUCCESS = 'success';

// Fulfillment Types
export const DELIVERY = 'DELIVERY';
export const DELIVERY_BY_RESTAURANT = 'DELIVERY BY RESTAURANT';
export const DINE_IN = 'DINE_IN';
export const CURBSIDE = 'CURBSIDE';
export const PICKUP = 'PICKUP';

export const CUBOH_REPORT_FULFILLMENT_TYPES = {
  [DELIVERY]: {
    key: DELIVERY,
    Icon: DeliveryIconSm,
    label: 'Delivery',
  },
  [DELIVERY_BY_RESTAURANT]: {
    key: DELIVERY_BY_RESTAURANT,
    Icon: DeliveryIconSm,
    label: 'Self Delivery',
  },
  [DINE_IN]: {
    key: DINE_IN,
    Icon: DineInIconSm,
    label: 'Dine In',
  },
  [CURBSIDE]: {
    key: CURBSIDE,
    Icon: CarIconSm,
    label: 'Curbside',
  },
  [PICKUP]: {
    key: PICKUP,
    Icon: ReceiptIconSm,
    label: 'Pickup',
  },
};

export const CANCEL_TYPES = {
  RESTAURANT: 'restaurant',
  DELIVERY_APP: 'delivery_application',
};
export const CANCEL_TYPES_FILTERS = [
  {
    text: 'Restaurant',
    value: 'Restaurant',
  },
  { text: 'Delivery Application', value: 'Delivery Application' },
];

export const INTEGRATION_NAME_MAP = {
  ubereats: 'Uber Eats',
  skip: 'SkipTheDishes',
  doordash: 'DoorDash',
  often: 'Auphan',
  squareapp: 'Square',
  allsetdev: 'Allset (Dev)',
  revel: 'Revel',
  clover: 'Clover',
  lunchbox: 'Lunchbox',
  ritual: 'Ritual',
  sociavore: 'Sociavore',
  chownow: 'ChowNow',
  grubhub: 'GrubHub',
  cuboh: 'Cuboh',
  flipdish: 'FlipDish',
  allset: 'Allset',
  mixbowl: 'Mixbowl',
  ezcater: 'EZCater',
  ezcaterdev: 'EZCater (Dev)',
  lightspeed: 'Lightspeed',
};

export const CN_REPORTS_TYPE = {
  aov: 'orders.aov',
  discounts: 'orders.discount_local',
  gfs: 'orders.gross_total_local',
  orderCount: 'orders.order_count',
  directDinerFeeShare: 'orders.service_charge_restaurant_share_local',
  subtotal: 'orders.subtotal_local',
  taxes: 'orders.tax_local',
  tips: 'orders.tip_local',
  uniqueDiners: 'orders.uniqueDiners',
};

export const CN_REPORTS_FILTERS = {
  brandId: 'orders.brand_id',
  restaurantId: 'orders.restaurant_id',
  date: 'orders.order_created_time_local',
  hourlyAverage: 'orders.order_created_hour_local',
  isCatering: 'orders.is_catering',
};

export const CN_REPORTS_DIMS = {
  orderSourceSegment: 'orders.order_source_segment',
};

export const CN_ITEM_REPORTS_TYPE = {
  gfs: 'order_items.gfs',
  itemQuantity: 'order_items.item_quantity',
};

export const CN_ITEM_REPORTS_DIMS = {
  itemName: 'order_items.order_item_name',
};

export const CN_ITEM_REPORTS_FILTERS = {
  brandId: 'order_items.brand_id',
  date: 'order_items.order_date_local',
  isCatering: 'order_items.is_catering',
  itemType: 'order_items.item_type',
  restaurantId: 'order_items.restaurant_id',
};

export const CN_CUBE_ROW_LIMIT = 1000;

export const CN_TIME_DIMENSION = {
  yesterday: { label: 'Yesterday', value: 'yesterday' },
  lastSevenDays: { label: 'Last 7 Days', value: 'last 7 days' },
  thisMonth: { label: 'This Month', value: 'this month' },
  lastMonth: { label: 'Last Month', value: 'last month' },
  thisYear: { label: 'This Year', value: 'this year' },
  lastYear: { label: 'Last Year', value: 'last year' },
};

export const TIME_DIMENSION_VALUES = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  LAST_7_DAYS: 'last_7_days',
  LAST_14_DAYS: 'last_14_days',
  THIS_MONTH: 'this_month',
  LAST_MONTH: 'last_month',
};

export const CUBOH_TIME_DIMENSION = {
  today: { label: 'Today', value: TIME_DIMENSION_VALUES.TODAY },
  yesterday: { label: 'Yesterday', value: TIME_DIMENSION_VALUES.YESTERDAY },
  lastSevenDays: { label: 'Last 7 Days', value: TIME_DIMENSION_VALUES.LAST_7_DAYS },
  lastFourteenDays: { label: 'Last 14 Days', value: TIME_DIMENSION_VALUES.LAST_14_DAYS },
  thisMonth: { label: 'This Month', value: TIME_DIMENSION_VALUES.THIS_MONTH },
  lastMonth: { label: 'Last Month', value: TIME_DIMENSION_VALUES.LAST_MONTH },
};

export const CHART_DATA_FORMAT = {
  currency: 'currency',
};

export const DEFAULT_TOTALS = {
  subTotal: {
    title: 'Sub Total',
    value: 0,
  },
  tip: {
    title: 'Tips',
    value: 0,
  },
  tax: {
    title: 'Sales Tax',
    value: 0,
  },
  deliveryFee: {
    title: 'Delivery Fees',
    value: 0,
  },
  discount: {
    title: 'Discounts',
    value: 0,
  },
  serviceFee: {
    title: 'Service Fees',
    value: 0,
  },
  subsidizedFee: {
    title: 'Subsidized Fees',
    value: 0,
  },
  processingFee: {
    title: 'Processing Fees',
    value: 0,
  },
  cancellations: {
    title: 'Total Cancellations',
    value: 0,
  },
  exceptions: {
    title: 'POS Errors',
    orderBy: 98,
    value: 0,
  },
  charges: {
    title: 'Total Upcharges',
    orderBy: 5,
    value: 0,
  },
  refunds: {
    title: 'Total Refunds',
    orderBy: 6,
    value: 0,
  },
  grossSales: {
    title: 'Gross Sales',
    orderby: 10,
    value: 0,
  },
  netSales: {
    title: 'Net Sales',
    orderby: 11,
    value: 0,
  },
  orderCount: {
    title: 'Order Count',
    orderBy: 12,
    value: 0,
  },
  average: {
    title: 'Avg. Order Value',
    orderBy: 13,
    value: 0,
  },
  errorRate: {
    title: 'POS Error Rate',
    orderBy: 99,
    value: '0%',
  },
};

// POS Errors
export const POS_UNKNOWN = 'POS_UNKNOWN';
export const POS_UNEXPECTED_ERROR = 'POS_UNEXPECTED_ERROR';
export const POS_WRONG_ITEM = 'POS_WRONG_ITEM';
export const POS_WRONG_MODIFIER = 'POS_WRONG_MODIFIER';
export const POS_MISSING_MAPPING = 'POS_MISSING_MAPPING';
export const POS_TIMEOUT = 'POS_TIMEOUT';
